import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FlexBox from '../../../components/FlexBox';
import Icon from '../../../components/Icon';

const ShareWrapper = styled(FlexBox)`
  justify-content: center;
  background-color: #fff;
  flex-wrap: wrap;
  
  .title {
    color: #212833;
    font-size: 16px;
    line-height: 21px;
    width: 100%;
    text-align: center;
  }
  
  .share-link {
    width: 50px;
    height: 50px;
    margin: 20px 20px 0;
    border: 1px solid #EAECEF;
    border-radius:50px;
    text-align: center;
    line-height: 50px;
  }
`;

const { object, string } = PropTypes;

export default class Share extends Component {
  static propTypes = { language: object, url: string }

  static defaultProps = { language: { } }

  share = (key) => {
    const {
      language: {
        shareInfoWb,
        shareInfoTw,
      },
      url = 'https://www.binance.com',
    } = this.props;
    if (key === 'weibo') {
      return `http://service.weibo.com/share/share.php?url=${url}&title=${encodeURIComponent(shareInfoWb)}`;
    }
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareInfoTw)}&url=${url}`;
  }

  render() {
    const { message } = this.props.language;
    const iconlist = [{
      type: 'twitter', color: '#1E91F1', key: 'twitter',
    }, {
      type: 'weibo', color: '#D22428', key: 'weibo',
    }];
    return (
      <ShareWrapper>
        <div className="title">{message}</div>
        {iconlist.map((item, key) => (
          <a href={this.share(item.key)} target="_blank" rel="noopener noreferrer nofollow" className="share-link" key={key}>
            <Icon size="22" type={item.type} color={item.color} />
          </a>))}
      </ShareWrapper>
    );
  }
}
